module.exports = require('./helpers/bundle-url').getBundleURL('37i63') + "logo-dark.eefe0b7f.svg";